import { getSearchLocation } from 'modules/search/zustand-stores/searchStore';
import { useUserEnvironment } from 'zustand-stores/userEnvironmentStore';

export function useSearchReady() {
  const { isEnvironmentLoaded } = useUserEnvironment();

  const initialSearchLocationSet = typeof getSearchLocation() !== 'undefined';

  const mainSearchReady = isEnvironmentLoaded && initialSearchLocationSet;

  return { mainSearchReady };
}
